import React__default from 'react';
import { css } from 'styled-components';
import En from '../translations/en/common.json.js';
import It from '../translations/it/common.json.js';
import allPrefix from './prefix.json.js';
var countries = require("i18n-iso-countries");
var sizes = {
  xl: 1500,
  giant: 1300,
  desktop: 992,
  tablet: 768,
  phone: 420
};
Object.keys(sizes).reduce(function (accumulator, label) {
  // use em in breakpoints to work properly cross-browser and support users
  // changing their browsers font-size: https://zellwk.com/blog/media-query-units/
  var emSize = sizes[label] / 16;
  accumulator[label] = function () {
    return css(["@media (max-width:", "em){", ";}"], emSize, css.apply(void 0, arguments));
  };
  return accumulator;
}, {});
function t() {
  var lng = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "en";
  var string = arguments.length > 1 ? arguments[1] : undefined;
  if (!string) return "";
  var path = string.split(".");
  var value = lng == "en" ? En : It;
  path.map(function (key) {
    value = value[key];
  });
  return value;
}
function parseColor(text, color) {
  var t = text.split("*color*");
  var array = [];
  t.map(function (p, index) {
    if (index != 0 && index % 2 != 0) {
      array.push( /*#__PURE__*/React__default.createElement("span", {
        key: index,
        style: {
          color: color,
          fontSize: "inherit",
          fontFamily: "inherit"
        }
      }, p));
    } else {
      array.push(p);
    }
  });
  return array;
}
function parseIcon(text, icon, size) {
  var t = text.split("*icon*");
  var array = [];
  t.map(function (p, index) {
    if (index != 0 && index % 2 != 0) {
      array.push( /*#__PURE__*/React__default.createElement("img", {
        href: icon,
        key: index,
        style: {
          display: "inline-block",
          width: size,
          height: size
        }
      }));
    } else {
      array.push(p);
    }
  });
  return array;
}
function checkPasswordStrenght(password) {
  var strength = 0;
  if (password && password.length >= 8) {
    strength = 25;
    if (password.match(/[a-z]+/)) {
      strength += 25;
    }
    if (password.match(/[A-Z]+/)) {
      strength += 25;
    }
    if (password.match(/[0-9]+/)) {
      strength += 25;
    }
  }
  return strength;
}
function getPrefixFromLng(country) {
  countries.registerLocale(require("i18n-iso-countries/langs/en.json"));
  var prefix = country && allPrefix && countries && allPrefix[countries.getName(country, "en")] ? allPrefix[countries.getName(country, "en")].prefix : null;
  return prefix;
}
export { checkPasswordStrenght, getPrefixFromLng, parseColor, parseIcon, t };